let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dwkwk")).then(() => parcelRequire('1mfCA'));